'use strict';

const createTextBoxFieldFactory = require('components/ui/field_text_box/js/main_creator');
const withProps = require('components-framework/view/with_props');
const Cvv2FieldView = require('./view');

module.exports = (config) => {
    return createTextBoxFieldFactory(Odigeo._.extend({
        name: 'cvv2_field',
        viewClass: withProps(Cvv2FieldView),
        methods: {
            onBlur() {
                this.onBlur();
            },
            onChange() {
                this.onChange();
            },
            appendTo($parent) {
                this.appendTo($parent);
            },
        },
    }, config));
};
